/**
 * Invoice Template Designer Route with Template ID
 */

import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { FeatureGate } from '@/components/ui/feature-gate'

export const Route = createFileRoute(
  '/(app)/dashboard/invoice-template/designer/$templateId',
)({
  component: DesignerRedirect,
})

function DesignerRedirect() {
  const { templateId } = Route.useParams()
  
  useEffect(() => {
    window.location.href = `/invoice-template?id=${templateId}`
  }, [templateId])
  
  return (
    <FeatureGate featureId="template-designer">
      <div>Wird geladen...</div>
    </FeatureGate>
  )
}
